<template>
  <div class="modal-window-body gray active">
    <div class="center-container">
      <div class="center-content">
        <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-search"></use></svg></div>
        <h2 class="bold">Søketips</h2>
        <p>Søk etter objekter, kunder, kunstnere eller fakturaer.</p>

        <div class="card">
          <ul class="border-list">
            <li>
              <span class="icon-heading">
                <span class="icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
                <span class="icon-heading-title">
                  <h5 class="bold">Objekter</h5>
                  <p>Objektnummer, tittel eller kunstner</p>
                </span>
              </span>
            </li>
            <li>
              <span class="icon-heading">
                <span class="icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-contract"></use></svg></span>
                <span class="icon-heading-title">
                  <h5 class="bold">Kontrakter</h5>
                  <p>Kontraktnr</p>
                </span>
              </span>
            </li>
            <li>
              <span class="icon-heading">
                <span class="icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
                <span class="icon-heading-title">
                  <h5 class="bold">Kunder</h5>
                  <p>Navn, email eller telefon</p>
                </span>
              </span>
            </li>
            <li>
              <span class="icon-heading">
                <span class="icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-artist"></use></svg></span>
                <span class="icon-heading-title">
                  <h5 class="bold">Kunstnere</h5>
                  <p>Navn</p>
                </span>
              </span>
            </li>
            <li>
              <span class="icon-heading">
                <span class="icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-artist"></use></svg></span>
                <span class="icon-heading-title">
                  <h5 class="bold">Fakturaer</h5>
                  <p>Faktura nr.</p>
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheMainSearchNormalIntro'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchNormalIntro.vue